import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: `
    <snap-scorecard
      [businessId]="accountGroupId"
      [partnerId]="partnerId"
      [snapshotName]="'COMMON.TERMS.SNAPSHOT_REPORT' | translate"
      [trackingCategory]="trackingCategory"
      [showEditButton]="showEditButton"
      (refreshReportClickedEvent)="onSnapshotRefreshClick()"
    ></snap-scorecard>
  `,
})
export class SnapshotDynamicScorecardComponent {
  @Input() accountGroupId: string;
  @Input() partnerId: string;
  @Input() trackingCategory: string;
  @Input() showEditButton: boolean;

  @Output() refreshReportClickedEvent: EventEmitter<void> = new EventEmitter<void>();

  onSnapshotRefreshClick(): void {
    this.refreshReportClickedEvent.emit();
  }
}
